/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_C11Inputs */

const en_job_form_enum_c11 = /** @type {(inputs: Job_Form_Enum_C11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C1 - Advanced`)
};

const de_job_form_enum_c11 = /** @type {(inputs: Job_Form_Enum_C11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C1 - Fachkundige Sprachkenntnisse`)
};

/**
* | output |
* | --- |
* | "C1 - Advanced" |
*
* @param {Job_Form_Enum_C11Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_c11 = /** @type {((inputs?: Job_Form_Enum_C11Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_C11Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_c11(inputs)
	return en_job_form_enum_c11(inputs)
});
export { job_form_enum_c11 as "job_form_enum_C1" }